var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusics = function SvgMusics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.969a.97.97 0 0 0-1.253-.925l-9.719 2.99a.75.75 0 0 0-.528.716v7.584A3.46 3.46 0 0 0 7 15c-1.656 0-3 1.119-3 2.5S5.344 20 7 20s3-1.119 3-2.5v-5.369l8.5-2.615v3.818A3.46 3.46 0 0 0 17 13c-1.656 0-3 1.119-3 2.5s1.344 2.5 3 2.5 3-1.119 3-2.5V4.969M18.5 15.5c0 .306-.403 1-1.5 1s-1.5-.694-1.5-1 .403-1 1.5-1 1.5.694 1.5 1m-10 2c0 .306-.403 1-1.5 1s-1.5-.694-1.5-1 .403-1 1.5-1 1.5.694 1.5 1m10-9.553L10 10.563V8.306l8.5-2.618v2.259"
  })));
};
export default SvgMusics;